<template>
    <div class="best-list">
        <div class="item" v-for="(item,index) in list" :key=" index" :class="index == cur?'cur':''"
        :style="'background-image:url('+item.titleImg+')'" @click.self="transgo(item)" @mouseenter="changeCur(index)" @mouseleave="changeCur(-1)">
            <small-swiper1 :info="item.query"></small-swiper1>
        </div>
    </div>
</template>
<script>
import smallSwiper1 from './smallSwiper'

export default {
    name:'more',
    components:{
        smallSwiper1,
      
    },
    data(){
        return {
            cur:-1,
            list:[
                {
                    titleImg: this.$common.themeImg('index/game01.png'),
                    conImg: this.$common.themeImg('index/159131702301.png'),
                    path:'/casino',
                    query:{
                        pid:5,
                        id:51,
                        type:2,
                        index:0
                    }
                },
                {
                    titleImg: this.$common.themeImg('index/game02.png'),
                    conImg: this.$common.themeImg('index/swiper1.png'),
                    path:'/slots',
                    query:{
                        pid:1,
                        id:  221,
                        type:1,
                        index:1
                    }
                },
                 {
                    titleImg: this.$common.themeImg('index/game03.png'),
                    conImg: this.$common.themeImg('index/159131710517.png'),
                    path:'/slot',
                    query:{
                        pid:1,
                        id: 212,
                        type:1,
                        index:2
                    }
                },
                 {
                    titleImg: this.$common.themeImg('index/game04.png'),
                    conImg: this.$common.themeImg('index/159131713376.png'),
                    path:'/chess',
                    query:{
                        pid:3,
                        id: 217,
                        type:1,
                        index:3
                    }
                },
            ]
        }
    },
    created(){
        if(window.projectImgUrl === 'gtg'){
            this.list = [
                {
                    titleImg:require(`@/assets/image/wbgj/game01.png`),
                    conImg:require('@/assets/image/wbgj/159131702301.png'),
                    path:'/casino',
                    query:{
                        pid:5,
                        id:51,
                        type:2,
                        index:0
                    }
                },
                {
                    titleImg:require('@/assets/image/wbgj/game02.png'),
                    conImg:require('@/assets/image/wbgj/swiper1.png'),
                    path:'/slots',
                    query:{
                        pid:1,
                        id: 158,
                        type:1,
                        index:1
                    }
                },
                 {
                    titleImg:require('@/assets/image/wbgj/game03.png'),
                    conImg:require('@/assets/image/wbgj/swiper1.png'),
                    path:'/slot',
                    query:{
                        pid:1,
                        id: 87,
                        type:1,
                        index:2
                    }
                },
                 {
                    titleImg:require('@/assets/image/wbgj/game04.png'),
                    conImg:require('@/assets/image/wbgj/159131713376.png'),
                    path:'/chess',
                    query:{
                        pid:3,
                        id: 62,
                        type:1,
                        index:3
                    }
                },
            ]
        }
        
    },
    methods:{
        changeCur(val){
            this.cur = val;
        },
        transgo(val){
            this.$router.push({
                path:val.path,
                query:val.query
            })
        }
    }
}
</script>
<style lang="less" scoped>

    .best-list {
        width: 1200px;
        height: 489px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item {
            position: relative;
            width: 280px;
            height: 489px;
            overflow: hidden;
            cursor:pointer;
            .title {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
            img {
                width: 280px;
                height: 978px;
            }
        }
        .cur{
            background-position:0 100%;
        }
        
    }
</style>